import { FC, useState, useEffect } from 'react'
import { ISectionTestArrangeWords, ISessionAnswer } from 'shared/types'
import { VStack, Text, HStack, Flex, Box } from '@chakra-ui/react'
import TestTask from 'shared/components/sections/tests/TestTask'
import get from 'lodash/get'
import omit from 'lodash/omit'
import find from 'lodash/find'
import map from 'lodash/map'
import trim from 'lodash/trim'
import replace from 'lodash/replace'
import shuffle from 'lodash/shuffle'
import last from 'lodash/last'
import has from 'lodash/has'
import isNil from 'lodash/isNil'
import forEach from 'lodash/forEach'
import { cleanupString, displayString, getTestTitle } from 'shared/utils/tests'
import TestCard from 'shared/components/sections/tests/TestCard'
import WordInputExamination from 'shared/components/sections/tests/WordInputExamination'
import DraggableWord, {
  IMatch
} from 'shared/components/sections/sectionTestArrangeWords/DraggableWord'
import DroppableArea from 'shared/components/sections/sectionTestArrangeWords/DroppableArea'
import DroppableAreaExamination from 'shared/components/sections/sectionTestArrangeWords/DroppableAreaExamination'

type Props = {
  s: ISectionTestArrangeWords
  onAnswer?: (sectionId: string, answer: ISessionAnswer) => void
  answer?: ISessionAnswer
  testNum?: number
  showUserAnswer?: boolean
  isExamination: boolean
}

const SectionTestArrangeWords: FC<Props> = ({
  s,
  onAnswer,
  answer: answerRaw,
  testNum,
  showUserAnswer,
  isExamination
}) => {
  const [textParts, setTextParts] = useState<string[][]>([])
  // const [addedWords, setAddedWords] = useState([])
  const [matches, setMatches] = useState<IMatch[]>([])

  console.log('matches', matches)

  useEffect(() => {
    if (matches.length > 0) {
      let answersAmount = 0
      let correctAmount = 0
      forEach(matches, (t) => {
        if (has(t, 'correct')) {
          answersAmount += 1
        }

        if (t.correct === true) {
          correctAmount += 1
        }
      })

      const sa: ISessionAnswer = {
        isCorrect:
          matches.length === answersAmount && answersAmount === correctAmount,
        answer: '',
        progress: {
          correctAmount,
          fullAmount: matches.length,
          completed: matches.length === answersAmount,
          answersAmount: answersAmount
        }
      }
      if (onAnswer) {
        onAnswer(s.id, sa)
      }
    }
  }, [matches])

  const answer =
    answerRaw && get(answerRaw.progress, 'completed', false)
      ? answerRaw
      : undefined

  // const findMatches = (str: string) => {
  //   const res = str.match(/\{(.*?)\}/g)
  //   console.log('findMatches', res)
  //   const orderedMatches = map(res, (m, i) => {
  //     const cleanString = cleanupString(m, false)
  //     return { id: cleanString + i.toString(), value: cleanString }
  //   })
  //   console.log('findMatches orderedMatches', orderedMatches)
  //   const matchesAt: IMatch[] = shuffle(orderedMatches)
  //   setMatches(matchesAt)
  // }

  useEffect(() => {
    const t = s.test?.text
    if (t) {
      // findMatches(t)
      // const cleanString = t.replace(/{\s*(.*?)\s*}/g, '{$1}')
      const cleanString = replace(
        t,
        /{\s*(.*?)\s*}/g,
        (v) => {
          // console.log('cleanString part:', v)
          return `{${v
            .substring(1, v.length - 1)
            .trim()
            .split(' ')
            .join('_')}}`
        }
        // v.split(' ').join('')
      )
      console.log('cleanString', cleanString)
      const sections = cleanString.split(/\r?\n/)
      const parts = map(sections, (s) => {
        const rawTokens = s.split(' ').filter((v) => v)
        const tokens: string[] = []
        forEach(rawTokens, (token) => {
          if (token.startsWith('{')) {
            const closeBraceIdx = token.indexOf('}')
            if (closeBraceIdx !== -1 && closeBraceIdx < token.length - 1) {
              tokens.push(token.substring(0, closeBraceIdx + 1))
              tokens.push(token.substring(closeBraceIdx + 1))
            } else {
              tokens.push(token)
            }
          } else {
            tokens.push(token)
          }
        })
        return tokens
      })
      console.log('parts', parts)
      setTextParts(parts)

      const orderedMatches = []
      forEach(parts, (section, sectionIndex) => {
        map(section, (t, i) => {
          if (t.startsWith('{')) {
            orderedMatches.push({
              id: `${sectionIndex}_${i}`,
              value: cleanupString(t, false),
              displayValue: displayString(t, false)
            })
          }
        })
      })
      console.log('findMatches orderedMatches', orderedMatches)
      const matchesAt: IMatch[] = shuffle(orderedMatches)
      setMatches(matchesAt)
    }
  }, [s.test?.text])

  // const onWordAdded = (isCorrect: boolean) => {
  //   // console.log('onWordAdded', isCorrect)
  //   const newAddedWords = [...addedWords, isCorrect]
  //   setAddedWords(newAddedWords)
  //   // console.log('newAddedWords', newAddedWords)
  //   // if (matches.length === newAddedWords.length) {
  //   const correctAnswers = newAddedWords.filter((v) => v !== null && v)
  //   // console.log('correctAnswers', correctAnswers)
  //   const answerIsCorrect = correctAnswers.length === newAddedWords.length
  //   const sa: ISessionAnswer = {
  //     isCorrect: answerIsCorrect && matches.length === newAddedWords.length,
  //     answer: '',
  //     progress: {
  //       correctAmount: correctAnswers.length,
  //       fullAmount: matches.length,
  //       completed: matches.length === newAddedWords.length,
  //       answersAmount: newAddedWords.length
  //     }
  //   }
  //   // console.log('session answer', sa)
  //   if (onAnswer) {
  //     onAnswer(s.id, sa)
  //   }
  //   // }
  // }

  const onDragEndResult = (value: string, attempts: boolean[]) => {
    console.log('onDragEndResult called with:', { value, attempts })
    const isCompleted = last(attempts) === true || attempts.length === 3
    console.log('isCompleted:', isCompleted)
    if (isCompleted) {
      setMatches((matches) => {
        let added = false
        const newMatches = map(matches, (m) => {
          if (!has(m, 'correct') && m.value === value && !added) {
            console.log('Updating match:', m)
            added = true
            return { ...m, correct: last(attempts) }
          } else {
            return m
          }
        })
        console.log('newMatches:', newMatches)
        return newMatches
      })
    }
  }

  const onDragEndResultExamination = (
    value: string,
    droppedValue: string,
    isCorrect: boolean,
    droppedDisplayValue?: string
  ) => {
    console.log('onDragEndResultExamination called with:', {
      value,
      droppedValue,
      isCorrect
    })
    setMatches((matches) => {
      let added = false
      const newMatches = map(matches, (m) => {
        console.log('onDragEndResultExamination', {
          m,
          value,
          droppedValue,
          isCorrect
        })
        if (m.value === value) {
          if (!added) {
            console.log('Updating match:', m)
            added = true
            return { ...m, correct: isCorrect, droppedValue, droppedDisplayValue }
          } else {
            return m
          }
        } else if (m.droppedValue === droppedValue) {
          return omit(m, ['correct', 'droppedValue', 'droppedDisplayValue'])
        } else {
          return m
        }
      })
      console.log('newMatches:', newMatches)
      return newMatches
    })
  }

  const renderTaskWords = () => {
    return (
      <HStack w='full' wrap={'wrap'}>
        {map(matches, (t, i) => {
          return (
            <DraggableWord
              t={t}
              key={i}
              isComplete={
                isExamination ? !showUserAnswer : !isNil(answer?.answer)
              }
              isExamination={isExamination}
            />
          )
        })}
      </HStack>
    )
  }

  const renderQuestion = () => {
    if (s.test) {
      return (
        <VStack
          justify={'flex-start'}
          align={'flex-start'}
          spacing={{ lg: 12, base: 8 }}
          pt={{ base: 4, lg: 8 }}
        >
          {renderTaskWords()}
          {map(textParts, (section, sectionIndex) => {
            return (
              <HStack
                key={sectionIndex}
                spacing={1}
                minH={6}
                // className='ql-snow'
                textStyle={'body'}
                // fontWeight={700}
                flexWrap='wrap'
                justify={'flex-start'}
                align={'flex-start'}
              >
                {map(section, (t, i) => {
                  // let wordNum = -1
                  if (t.startsWith('{')) {
                    // wordNum++

                    const correctValues = t
                      .substring(1, t.length - 1)
                      .split('/')
                      .map((s) => trim(s).split('_').join(' '))
                    if (isExamination) {
                      const match = find(
                        matches,
                        (m) => m.id === `${sectionIndex}_${i}`
                      )
                      return (
                        <DroppableAreaExamination
                          key={i}
                          value={cleanupString(t, false)}
                          displayValue={displayString(t, false)}
                          onDragEndResult={onDragEndResultExamination}
                          isComplete={!showUserAnswer}
                          droppedValue={get(match, 'droppedValue')}
                          droppedDisplayValue={get(match, 'droppedDisplayValue')}
                        />
                        // <WordInputExamination
                        //   correctValues={correctValues}
                        //   key={i}
                        //   onWordAdded={(isCorrect: boolean) =>
                        //     onWordAdded(isCorrect)
                        //   }
                        //   completed={!isNil(answer)}
                        //   highlightCorrectAnswer={
                        //     !showUserAnswer &&
                        //     get(s, 'test.highlightCorrectAnswer', false)
                        //   }
                        //   showUserAnswer={showUserAnswer}
                        // />
                      )
                    } else {
                      return (
                        // <VStack
                        //   align='flex-end'
                        //   flex={1}
                        //   justify={'flex-start'}
                        //   spacing={1}
                        //   fontWeight={700}
                        //   color='darkGray'
                        //   w='fit-content'
                        // >
                        <DroppableArea
                          key={i}
                          value={cleanupString(t, false)}
                          displayValue={displayString(t, false)}
                          onDragEndResult={onDragEndResult}
                        />

                        // </VStack>
                      )
                    }
                  }
                  return (
                    <Flex
                      h={8}
                      align={'flex-start'}
                      justify={'flex-start'}
                      key={i}
                      pt={1}
                      pr={1}
                    >
                      <Text as='span' key={i}>
                        {t}
                      </Text>
                    </Flex>
                  )
                })}
              </HStack>
            )
          })}
        </VStack>
      )
    }
  }

  return (
    <TestCard showUserAnswer={showUserAnswer} answer={answer}>
      <TestTask
        title={s.test?.title || getTestTitle(s.type)}
        answer={showUserAnswer ? undefined : answer}
        testNum={testNum}
      />
      {renderQuestion()}
    </TestCard>
  )
}

export default SectionTestArrangeWords
